import { useMutation, useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import showErrorToast, { ErrorToastConfig } from "../../../components/Error";
import { AuthService } from "../../../services/auth.service";
import { BusinessService } from "../../../services/business.service";
import {
  IAuth,
  mixpanelProfilePayload,
  useAuthStore,
} from "../../../store/session";
import { IBusinessResponse } from "../../../types/business";
import { TrackerService } from "../../../services/tracker.service";
import { TRACKER_CONSTANTS } from "../../../constants/tracker.events.ts";
import { useEffect } from "react";

interface IProps {
  isOpen: boolean;
}

const useContainer = ({ isOpen }: IProps) => {
  const getSelectableBusinesses = useQuery<IBusinessResponse[]>({
    queryKey: ["selectable-businesses"],
    queryFn: BusinessService.getSelectableBusiness,
    enabled: isOpen,
  });
  const { login, session } = useAuthStore();
  const chooseBusiness = useMutation({
    mutationFn: AuthService.chooseBusinessAfterLogin,
    onSuccess: ({ data }: { data: IAuth }) => {
      localStorage.removeItem("businessChooseToken");
      if (data) {
        TrackerService.identify(
          data.account.email || data.account.phoneNumber || "unknown",
          mixpanelProfilePayload(data)
        );
        TrackerService.track(
          TRACKER_CONSTANTS.LOGIN_SUCCESS.events.CompanyOptionsClicked,
          {
            ...session,
          }
        );
      }

      const recaptchaContainer = document.getElementById("recaptcha-container");
      if (recaptchaContainer) {
        recaptchaContainer.remove();
      }

      if (window.recaptchaVerifier) {
        delete (window as any).recaptchaVerifier;
      }

      login(data);

      const signInMethod = localStorage.getItem("method") || "signin-email";
      if (signInMethod === "signin-phone") {
        localStorage.removeItem("mobile");
        localStorage.removeItem("method");
      }
      window.location.href = "/client";
    },
    onError: (error) => {
      toast(showErrorToast(error), ErrorToastConfig);
    },
  });

  /**
   * automatically select the first business if there is only one business
   * and the businessAccountType is BUYER
   */
  useEffect(() => {
    if (
      getSelectableBusinesses.data?.length === 1 &&
      getSelectableBusinesses.data[0].businessAccountType === "BUYER"
    ) {
      chooseBusiness.mutate(getSelectableBusinesses.data[0].id);
    }
  }, [getSelectableBusinesses.data]);

  //#region handler functions
  function itemClickHandler(businessId: string) {
    chooseBusiness.mutate(businessId);
  }

  //#endregion
  return {
    isLoading: getSelectableBusinesses.isPending || chooseBusiness.isPending,
    businesses: getSelectableBusinesses.data,
    itemClickHandler,
  };
};

export default useContainer;
